export default __webpack_public_path__ + "static/media/airfields.7948680a.kml";